import React, { useState, memo } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
export const NewCource = memo((props) => {
  const { cm, addCource } = props;
  const initialCourceState = {
    code: '',
    sort_id: '',
    name_ja: '',
    name_en: '',
    desc_ja: '',
    desc_en: ''
  }
  const [cource, setCource] = useState(initialCourceState);

  const onChangeCode = e => setCource({ ...cource, code: e.target.value });
  const onChangeSortId = e => setCource({ ...cource, sort_id: e.target.value });
  const onChangeJa = e => setCource({ ...cource, name_ja: e.target.value });
  const onChangeEn = e => setCource({ ...cource, name_en: e.target.value });
  const onChangeJaDesc = e => setCource({ ...cource, desc_ja: e.target.value });
  const onChangeEnDesc = e => setCource({ ...cource, desc_en: e.target.value });
  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onClickCreateSubmit = () => {
    if (!cource.code || !cource.sort_id || !cource.name_ja || !cource.name_en) {
      alert("※入力必須です。");
      return
    }

    var data = {item: {
        code: cource.code,
        sort_id: cource.sort_id,
        translations_attributes: [
          {locale: "ja", name: cource.name_ja.trim(), description: cource.desc_ja.trim()},
          {locale: "en", name: cource.name_en.trim(), description: cource.desc_en.trim()}
        ]
    }}

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/cm/${cm}/cources`, data)
    .then(resp => {
      console.log(resp.data);
      addCource(resp.data);
      notify("success", "Cource successfully created!");
      setCource({
        code: '',
        sort_id: '',
        name_ja: '',
        name_en: '',
        desc_ja: '',
        desc_en: ''
      });
    })
    .catch(e => {
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Cource create Error!");
    })
  }

  return (
    <tr>
      <td>
        <input type="number" className="form-control" placeholder="code" value={cource.code} onChange={onChangeCode} />
      </td>
      <td>
        <input type="number" className="form-control" placeholder="sort_id" value={cource.sort_id} onChange={onChangeSortId} />
      </td>
      <td>
          <input type="text" className="form-control" placeholder="ラベル名" value={cource.name_ja} onChange={onChangeJa} />
          <input type="text" className="form-control" placeholder="備考" value={cource.desc_ja} onChange={onChangeJaDesc} />
      </td>
      <td>
          <input type="text" className="form-control" placeholder="ラベル名" value={cource.name_en} onChange={onChangeEn} />
          <input type="text" className="form-control" placeholder="備考" value={cource.desc_en} onChange={onChangeEnDesc} />
      </td>
      <td colSpan="4">
        <button 
          onClick={onClickCreateSubmit} 
          className="btn btn-primary" 
          disabled={(
            !cource.code 
            || !cource.sort_id 
            || !cource.name_ja 
            || !cource.name_en
          )}
        >
          <i className="far fa-plus-square" /> 追加
        </button>
      </td>
    </tr>
  );
});
